import { CSSProperties } from 'react';
import { Stack, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { isEmpty } from 'lodash';

import { IProductDto } from 'api/products/dto';

type Props = {
  products: IProductDto[];
  sx?: CSSProperties;
};

const ProductsTooltip = (props: Props) => {
  const { products, sx } = props;
  return (
    <Stack
      textAlign="center"
      alignItems="center"
      spacing={0.5}
      direction="row"
      height={'100%'}
      sx={{ display: isEmpty(products) ? 'none' : 'flex', ...sx }}
    >
      <Tooltip
        title={
          <Stack direction={'column'} spacing={1}>
            {products?.map((product, index) => {
              return (
                <Stack key={`${product?.name}${index}`} direction="row" width="100%" gap={2}>
                  <Typography variant="body2" color="white" sx={{ minWidth: '2rem' }}>
                    {product?.quantity}
                  </Typography>
                  <Typography variant="body2" color="white" sx={{ minWidth: '2rem' }}>
                    x
                  </Typography>
                  <Typography variant="body2" color="white">
                    {product?.name}
                  </Typography>
                </Stack>
              );
            })}
          </Stack>
        }
      >
        <InfoOutlinedIcon sx={{ fontSize: '1.2rem', color: 'gray' }} />
      </Tooltip>
    </Stack>
  );
};

export default ProductsTooltip;
